import { combineReducers } from 'redux';
import funnel from './funnel';
import questions from './questions';
import answers from './answers';
import scores from './scores';
import exclusions from './exclusions';
import advices from './advices';
import products from './products';
import history from './history';

export const funnelReducer = combineReducers({
  funnel,
  questions,
  answers,
  scores,
  exclusions,
  advices,
  products,
  history,
});



// WEBPACK FOOTER //
// ./src/modules/funnel/reducers/index.js